import { map, filter, find, isEmpty } from 'lodash-es';
import React, { useCallback, useEffect, useState } from 'react';
import { updateHubspotContact } from '..';
import { LayoutTitle, LayoutFooter, LayoutDescription } from './Layout';
import { formatMoney } from '../../../common/utils';
import Button from '../../../components/Button';
import { PlansTable } from '../../../components/PlansTable';
export const Plans = ({ fields, updateFields, nextSection, onLoading }) => {
    var _a;
    const plans = fields.plans;
    const [selectedPlan, setSelectedPlan] = useState(fields.selectedPlan);
    useEffect(() => {
        if (!selectedPlan) {
            const recommendedPlan = find(plans, { name: 'silver' }) || null;
            setSelectedPlan(recommendedPlan);
        }
    }, []);
    const updateSelectedPlan = useCallback((plan) => {
        setSelectedPlan(plan);
    }, [setSelectedPlan]);
    const nextStep = useCallback(async () => {
        onLoading(true);
        const { hsCompanyId, hsContactId } = await updateHubspotContact(Object.assign(Object.assign({}, fields), { selectedPlan }));
        updateFields({ selectedPlan, hsCompanyId, hsContactId });
        onLoading(false);
        nextSection();
    }, [fields, nextSection, updateHubspotContact, onLoading, updateFields, selectedPlan]);
    const trialPlan = find(plans, 'is_trial');
    const recommendedPlan = 'silver';
    return (React.createElement("div", { className: "register-plans" },
        React.createElement(LayoutTitle, { text: "Choose Your Plan" }),
        React.createElement(LayoutDescription, { text: "Kickstart your call tracking journey with TrackNotion and gain immediate\n      access to a 14-day free trial. Completing this form is your first step towards a customized setup,\n      ensuring you get the most out of our services. Together, let's revolutionize the way you measure calls." }),
        trialPlan &&
            React.createElement("div", { className: 'trial-plan' },
                React.createElement("h2", { className: 'trial-plan__header' }, "Free Trial"),
                React.createElement("div", { className: 'trial-plan__details-container' },
                    React.createElement("div", { className: 'trial-plan__details' },
                        React.createElement("div", { className: 'trial-plan__info' },
                            React.createElement("div", { className: "trial-plan__price" },
                                React.createElement("div", null, formatMoney(parseFloat(trialPlan.price))),
                                "/mo"))),
                    React.createElement("div", { className: 'trial-plan__details' },
                        React.createElement("div", { className: 'trial-plan__info' },
                            React.createElement("span", null, trialPlan.total_local_numbers),
                            " Local Number")),
                    React.createElement("div", { className: 'trial-plan__details' },
                        React.createElement("div", { className: 'trial-plan__info' },
                            React.createElement("span", null, trialPlan.total_local_minutes),
                            " Local Minutes")),
                    React.createElement("div", { className: 'trial-plan__details' },
                        React.createElement(Button, { variant: (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id) !== trialPlan.id ? 'marketing-border' : 'marketing-solid', onClick: () => updateSelectedPlan(trialPlan) }, (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id) === trialPlan.id ? 'Selected' : 'Start free trial')))),
        React.createElement(PlansTable, { plans: map(filter(plans, { is_trial: false })), selectedPlanId: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id, recommendedPlanId: (_a = find(plans, { name: recommendedPlan })) === null || _a === void 0 ? void 0 : _a.id, planActionLabel: plan => (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id) === plan.id ? 'Selected' : 'Select', planCallback: updateSelectedPlan }),
        React.createElement(LayoutFooter, { positionShouldChange: true },
            React.createElement(Button, { variant: 'marketing-solid', disabled: selectedPlan === null || isEmpty(plans), onClick: nextStep }, "Next"))));
};
